import type { FinancialRating } from '../types';

export function ratingLabel(rating: FinancialRating): string {
  switch (rating) {
    case 'excellent':
      return 'Keep / strong';
    case 'good':
      return 'Fine';
    case 'neutral':
      return 'Monitor';
    case 'bad':
      return 'Improve';
    case 'critical':
      return 'Reduce / remove';
    default:
      return '';
  }
}

export function ratingClass(rating: FinancialRating): string {
  return `rating-badge rating-${rating}`;
}
